'use strict';

var currencies = require('./currencies');
var constants = {
    currencies: {},
    symbols: {
        GBP: '£',
        EUR: '€',
        USD: '$',
        CAD: '$',
        AUD: '$',
        CHF: '', // Swiss francs don't have a currency symbol
        MXN: '$'
    },
    abbreviations: {
        CAD: 'CAD',
        AUD: 'AUD',
        MXN: 'MXN',
        CHF: 'CHF'
    },
    flags: {
        sm: {},
        md: {}
    }
};
currencies.forEach(function (currency) {
    constants.flags.sm[currency] = 'https://a.1stdibscdn.com/assets/currency-flags/1x/flag_'+currency.toLowerCase()+'.png';
    constants.flags.md[currency] = 'https://a.1stdibscdn.com/assets/currency-flags/2x/flag_'+currency.toLowerCase()+'.png';
});
currencies.forEach(function (currency) {
    constants.currencies['CURRENCY_' + currency] = currency;
});

module.exports = constants;



//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-currency-helpers/constants.js
// module id = ./node_modules/dibs-currency-helpers/constants.js
// module chunks = 4